import { useCallback, useEffect, useState } from 'react'
import { useAccount } from 'wagmi'

import { logError } from 'utils/logger'

export const useContractManager = ({ contract }: { contract: any }) => {
  const { address } = useAccount()

  const [isContractManager, setIsContractManager] = useState(false)

  const checkContractManager = useCallback(async () => {
    try {
      if (contract && address) {
        const res = await contract.read.whitelistManagers([address])

        console.log('res------', res)

        setIsContractManager(Boolean(res))
      } else {
        setIsContractManager(false)
      }
    } catch (error: any) {
      setIsContractManager(false)
      logError(error)
    }
  }, [address, contract])

  useEffect(() => {
    checkContractManager()
  }, [address, contract, checkContractManager])

  return {
    isContractManager,
    checkContractManager,
  }
}
